import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNicheFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.1268 8.12772C4.19985 9.51213 3.25 11.5312 3.25 13.9995C3.25 18.962 7.08859 22.7495 12 22.7495C16.9114 22.7495 20.75 18.962 20.75 13.9995C20.75 9.64257 18.6151 6.4621 16.5273 4.39801C14.9567 2.84526 13.1755 1.83734 11.25 0.810547C11.25 2.39291 13.1182 11.2495 10 11.2495C7.50784 11.2495 8.25 6.63385 8.25 4.88493C7.03689 5.90898 6.04322 6.75904 5.1268 8.12772Z",
		fill: "currentColor"
	})
});
export default SvgNicheFilled;
